<template>
  <div :class="['main-box', {'h5-components': h5Components.indexOf($route.name) !== -1}]" id="appMainBox">
    <div class="body-content">
      <div class="body-header">
        <e-header></e-header>
      </div>
      <div class="content-box" id="bodyContentBox">
        <keep-alive :include="$config.keepAliveList">
          <router-view></router-view>
        </keep-alive>
      </div>
      <div class="body-footer">
        <e-footer></e-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'
  // 组件化
  import EHeader from './common/e-header'
  import EFooter from './common/e-footer'

  export default {
    name: 'e-main',
    data() {
      return {
        h5Components: ['controlEpAuth','controlSimpleAuth','authResult','authResult'] // 需要兼容h5的组件
      }
    },
    components: {
      EHeader,
      EFooter
    },
    computed: {
      
    },
    mounted() {
      let token = localStorage.getItem('token')
      let expiresIn = localStorage.getItem('expiresIn')
      let expireTime = new Date(expiresIn).getTime()
      let nowTime = new Date().getTime()
      if(token && nowTime <= expireTime) {
        this.getUserInfo() // 浏览器缓存 自动登录
      }
    },
    methods: {
      ...mapActions(['getUserInfo']),
    }
  }
</script>

<style lang="scss" scoped>
  .main-box {
    position: absolute;
    min-width: 1260px;
    width: 100%;
    height: 100%;
    background: #fff;
  }
  .body-content {
    position: relative;
    width: 100%;
    min-height: 100%;
    padding: 66px 0;
    box-sizing: border-box;
  }
  .body-header {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .body-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .content-box {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/main.vue